// This enum consist of all the actions supported in the Upload Template page
export const ActionType={
    TRANSFORM: 0,
    TEXT: 1,
    SCRIBBLE: 2,
    FILLCELL: 3,
    FILLREGION: 4,
    ERASE: 5,
    SELECT:6
}